import { PropsWithChildren, useContext } from 'react'
import Image from 'next/image'
import { WHeading } from '@alice-health/wonderland-react'
import { SimulatorContext } from '@/modules/simulator/contexts'

const SimulatorContainer = ({ children }: PropsWithChildren) => {
  const { simulatorWrapperRef } = useContext(SimulatorContext)

  return (
    <div
      className='h-[calc(100vh-60px)] flex'
      data-testid='simulator-container'
    >
      <div className='hidden'>
        <WHeading>
          Faça uma cotação do plano de saúde Alice em poucos cliques
        </WHeading>
      </div>

      <div className='hidden sm:block'>
        <Image
          className='hidden sm:block h-full object-cover object-left'
          src='/images/simulator/background.jpg'
          height={4626}
          width={6935}
          priority
          alt='Pessoa sentada em uma poltrona usando um notebook no colo'
        />
      </div>

      <div
        className='w-full sm:w-[490px] sm:shrink-0 overflow-y-auto'
        ref={simulatorWrapperRef}
      >
        {children}
      </div>
    </div>
  )
}

export { SimulatorContainer }
